module.exports = __webpack_public_path__ + "static/media/gateway.6e21c6db.png";